import type { DocumentStatus, FlowAction } from './types';

// Qué modal abre cada acción de la etapa (lógica pura). Toda acción con consecuencia
// pasa por confirmación; ninguna se ejecuta al primer click (UX-FB-01).

export type EditorModal =
  | { kind: 'return'; toStatus: DocumentStatus }
  | { kind: 'transition'; toStatus: DocumentStatus }
  // G2: avance forzado por Calidad (pide motivo), conformidad y cierre de la aprobación.
  | { kind: 'forced'; toStatus: DocumentStatus }
  | { kind: 'conformity' }
  | { kind: 'close-approval' }
  | { kind: 'start-modification' }
  | { kind: 'decommission' }
  | { kind: 'approve' }
  | null;

export function modalFor(a: FlowAction): EditorModal {
  switch (a.action) {
    case 'transition':
      if (a.toStatus === undefined) {
        return null;
      }
      return a.requiresReason === true
        ? { kind: 'forced', toStatus: a.toStatus }
        : { kind: 'transition', toStatus: a.toStatus };
    case 'return':
      return a.toStatus === undefined ? null : { kind: 'return', toStatus: a.toStatus };
    case 'review-conformity':
      return { kind: 'conformity' };
    case 'close-approval':
      return { kind: 'close-approval' };
    case 'approve':
    case 'decommission':
    case 'start-modification':
      return { kind: a.action };
    default:
      return null;
  }
}
